<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      label-position="top"
      :validate-on-rule-change="false"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="联系人姓名" prop="contactName">
            <el-input
              v-model="formData.contactName"
              placeholder="请输入联系人姓名"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="联系人手机" prop="contactMobile">
            <el-input
              v-model="formData.contactMobile"
              placeholder="请输入联系人手机"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="固定电话">
            <el-input
              v-model="formData.contactPhone"
              placeholder="请输入固定电话"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="联系人Email" prop="contactEmail">
            <el-input
              v-model="formData.contactEmail"
              placeholder="请输入联系人Email"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="联系人职务">
            <el-input
              v-model="formData.contactJob"
              placeholder="请输入联系人职务"
              maxlength="25"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="是否有效" prop="contactStatus">
            <el-radio-group v-model="formData.contactStatus">
              <el-radio label="Y">有效</el-radio>
              <el-radio label="N">无效</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="是否允许登录系统" prop="allowLogin">
            <el-radio-group
              v-model="formData.allowLogin"
              @change="onAllowLoginChange"
            >
              <el-radio label="Y">允许</el-radio>
              <el-radio label="N">不允许</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="登录密码" prop="contactLoginPwd" ref="loginPwdForm">
            <el-input
              v-model="formData.contactLoginPwd"
              placeholder="请输入登录密码"
              :disabled="!allowLogin"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="登录角色" prop="loginRole" ref="loginRoleForm">
            <dict-select
              v-model="formData.loginRole"
              style="width: 100%"
              default
              size="small"
              filterable
              clearable
              multiple
              :body="loginRoleDictParams"
              :disabled="!allowLogin"
            >
            </dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="联系人备注">
            <el-input
              clearable
              v-model="formData.contactRemarks"
              placeholder="请输入联系人备注"
              type="textarea"
              maxlength="100"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    contactCode: { type: String, default: '' },
    carrierCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: { contactStatus: 'Y', allowLogin: 'N' },
      loginRoleDictParams: { type: 'carrierRole' },
    }
  },
  computed: {
    allowLogin() {
      return this.formData.allowLogin === 'Y'
    },
    rules() {
      return {
        contactName: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
        ],
        contactMobile: [
          { required: true, message: '请输入联系人手机', trigger: 'blur' },
          {
            pattern: /^\d{11}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur',
          },
        ],
        contactEmail: [
          {
            pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
            message: '请输入正确的邮箱',
            trigger: 'blur',
          },
        ],
        contactStatus: [
          { required: true, message: '请选择是否有效', trigger: 'change' },
        ],
        allowLogin: [
          {
            required: true,
            message: '请选择是否允许登录系统',
            trigger: 'change',
          },
        ],
        contactLoginPwd: [
          {
            required: this.allowLogin && !this.contactCode,
            message: '请输入登录密码',
            trigger: 'blur',
          },
          {
            min: 5,
            max: 10,
            message: '新密码必须是5-10位',
            trigger: 'blur',
          },
        ],
        loginRole: [
          {
            required: this.allowLogin,
            message: '请选择登录角色',
            trigger: 'change',
          },
        ],
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.contactCode) return
      this.$api
        .masterCarrierContactDetailApi({
          contactCode: this.contactCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)

      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      this.$api
        .masterCarrierContactSaveApi({
          ...this.formData,
          carrierCode: this.carrierCode,
        })
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    onAllowLoginChange(e) {
      if ('N' === e) {
        this.$refs.loginRoleForm.clearValidate()
        this.$refs.loginPwdForm.clearValidate()
      }
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
